import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

import {
  Button,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Glyphicon,
  Overlay,
  OverlayTrigger,
  Popover,
  Tooltip,
} from 'react-bootstrap';

import DriverStatusCard from './DriverStatusCard';
import LoadingCircle from '../../ui/LoadingCircle';

import { ON_DUTY, OFF_DUTY } from '../../../constants/DriverStatus';

class DriverBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      pages: 1,
      pageSize: 20,
      selected: null,
      showFiltersTooltip: false,
    };
  }
  UNSAFE_componentWillReceiveProps(props) {
    if (typeof props.drivers !== 'undefined') {
      const drivers = props.drivers;
      const pageSize = this.state.pageSize;

      const pages = Math.ceil(drivers.length / pageSize);
      this.setState({
        pages,
      });
    }

    if (
      props.available !== this.props.available ||
      props.equipmentType !== this.props.equipmentType
    ) {
      this.setState({
        currentPage: 1,
      });
    }
  }
  getVisibleDrivers() {
    const { currentPage, pageSize } = this.state;
    const begin = (currentPage - 1) * pageSize;
    const end = begin + pageSize;
    return this.props.drivers.slice(begin, end);
  }
  getStatus() {
    const available = this.props.available;
    switch (available) {
      case true:
        return ON_DUTY;
      case false:
        return OFF_DUTY;
      default:
        return '';
    }
  }

  getFiltersOverlay() {
    return (
      <Popover id="driver-filters-popover">
        <Form horizontal>
          {this.renderStatusFilter()}
          {this.renderEquipmentTypeFilter()}
        </Form>
      </Popover>
    );
  }

  addAddDriverTooltip() {
    const { t } = this.props;
    return <Tooltip id="add-driver-tooltip">{t('ADD_DRIVER')}</Tooltip>;
  }

  hasPrev() {
    const { currentPage, pages } = this.state;

    return pages > 1 && currentPage > 1;
  }
  hasNext() {
    const { currentPage, pages } = this.state;

    return pages > 1 && currentPage < pages;
  }

  handleDriverToggled = (driver) => {
    const currentSelected = this.state.selected;
    let selected = null;
    let coords = null;

    if (currentSelected === driver.id) {
      selected = null;
      coords = this.props.market.center.coords;
    } else {
      selected = driver.id;
      coords = driver.coords;
    }

    this.setState({
      selected,
    });

    if (coords) {
      this.props.onDriverToggled(coords);
    }
  };
  handleClickNext = (e) => {
    e.preventDefault();
    const { currentPage, pages } = this.state;

    if (currentPage < pages) {
      this.setState({
        currentPage: currentPage + 1,
      });
    }
  };
  handleClickPrev = (e) => {
    e.preventDefault();
    const { currentPage } = this.state;

    this.setState({
      currentPage: currentPage - 1,
    });
  };

  handleFiltersButtonMouseEnter = () => {
    this.setState({
      showFiltersTooltip: true,
    });
  };

  handleFiltersButtonMouseLeave = () => {
    this.setState({
      showFiltersTooltip: false,
    });
  };

  renderStatusFilter() {
    const status = this.getStatus();
    const { t } = this.props;
    return (
      <FormGroup controlId="driverStatus">
        <Col componentClass={ControlLabel} sm={4}>
          {t('STATUS')}
        </Col>
        <Col sm={8}>
          <FormControl
            componentClass="select"
            value={status}
            onChange={(e) => this.props.onAvailabilityChange(e.target.value)}
          >
            <option key="any" value="">
              {t('ANY')}
            </option>
            <option key={ON_DUTY} value={ON_DUTY}>
              {t('ON_DUTY')}
            </option>
            <option key={OFF_DUTY} value={OFF_DUTY}>
              {t('OFF_DUTY')}
            </option>
          </FormControl>
        </Col>
      </FormGroup>
    );
  }
  renderEquipmentTypeFilter() {
    const { t } = this.props;
    return (
      <FormGroup controlId="equipmentType">
        <Col componentClass={ControlLabel} sm={4}>
          {t('EQUIPMENT_TYPE')}
        </Col>
        <Col sm={8}>
          <FormControl
            componentClass="select"
            value={this.props.equipmentType}
            onChange={(e) => this.props.onEquipmentTypeChange(e.target.value)}
          >
            <option value="">{t('ANY')}</option>
            {this.props.equipmentTypes.map((equipmentType) => (
              <option key={equipmentType.label} value={equipmentType.label}>
                {t(equipmentType.label)}
              </option>
            ))}
          </FormControl>
        </Col>
      </FormGroup>
    );
  }

  renderActionButtons() {
    const { t } = this.props;
    return (
      <div className="driver-filters">
        <OverlayTrigger
          placement="bottom"
          trigger={['click']}
          overlay={this.getFiltersOverlay()}
        >
          <Button
            title={t('FILTER', { count: 1 })}
            className="btn-circle btn-circle-md"
            ref={(button) => {
              this.filterButton = button;
            }}
            onMouseEnter={this.handleFiltersButtonMouseEnter}
            onMouseLeave={this.handleFiltersButtonMouseLeave}
          >
            <Glyphicon glyph="filter" />
          </Button>
        </OverlayTrigger>
        <Overlay
          show={this.state.showFiltersTooltip}
          container={this}
          placement="bottom"
          target={() => this.filterButton}
        >
          <Tooltip id="overload-left">{t('FILTER_DRIVERS')}</Tooltip>
        </Overlay>
        <OverlayTrigger placement="bottom" overlay={this.addAddDriverTooltip()}>
          <Button
            className="btn-circle btn-circle-md"
            onClick={() => this.props.onAddDriverButtonClick()}
            title={t('ADD_DRIVER')}
          >
            <Glyphicon glyph="plus" />
          </Button>
        </OverlayTrigger>
      </div>
    );
  }
  renderPrevButton() {
    const disabled = !this.hasPrev();
    return (
      <div className="driver-control">
        <Button
          block
          className="driver-control-btn"
          disabled={disabled}
          onClick={this.handleClickPrev}
        >
          <Glyphicon glyph="chevron-left" />
        </Button>
      </div>
    );
  }
  renderNextButton() {
    const disabled = !this.hasNext();
    return (
      <div className="driver-control">
        <Button
          block
          disabled={disabled}
          className="driver-control-btn"
          onClick={this.handleClickNext}
        >
          <Glyphicon glyph="chevron-right" />
        </Button>
      </div>
    );
  }
  renderLoadingIndicator() {
    const { loading, t } = this.props;

    if (!loading) {
      return null;
    }

    return (
      <small>
        <LoadingCircle text={`${t('LOADING_DRIVERS')}...`} size={2} />
      </small>
    );
  }
  renderEmptyState() {
    const { loading, drivers, t } = this.props;

    if (loading || drivers.length > 0) {
      return null;
    }

    return <small>{t('THERE_ARE_NO_DRIVERS')}...</small>;
  }
  renderLoadedState() {
    const visibleDrivers = this.getVisibleDrivers();
    return (
      <div className="driver-cards">
        {visibleDrivers.map((driver) => {
          const selected = this.state.selected === driver._id;
          return (
            <DriverStatusCard
              key={driver._id}
              driver={driver}
              selected={selected}
              onDriverCardClick={this.handleDriverToggled}
            />
          );
        })}
      </div>
    );
  }
  renderDriverCards() {
    return (
      <div className="flex justify-center w-full pt-4">
        {this.renderPrevButton()}
        {this.renderLoadingIndicator()}
        {this.renderEmptyState()}
        {this.renderLoadedState()}
        {this.renderNextButton()}
      </div>
    );
  }
  render() {
    return (
      <div className="driver-bar bg-grey-light">
        {this.renderDriverCards()}
        {this.renderActionButtons()}
      </div>
    );
  }
}

DriverBar.propTypes = {
  loading: PropTypes.bool,
  drivers: PropTypes.array,
  onDriverToggled: PropTypes.func.isRequired,
  onAddDriverButtonClick: PropTypes.func.isRequired,
  market: PropTypes.shape({
    code: PropTypes.string.isRequired,
    center: PropTypes.shape({
      coords: PropTypes.array,
    }).isRequired,
  }).isRequired,
  equipmentTypes: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  equipmentType: PropTypes.string,
  available: PropTypes.bool,
  onEquipmentTypeChange: PropTypes.func.isRequired,
  onAvailabilityChange: PropTypes.func.isRequired,
};

DriverBar.defaultProps = {
  loading: true,
  equipmentType: '',
  available: true,
  drivers: [],
};
export default withTranslation()(DriverBar);
